// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "meta_ad".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { adLinkSourceValues, adPlacementValues, conversionDestinationAllValues, followUpTypeValues, metaAdStatusValues, metaCallToActionValues } from '@borradh-workspace/labels';
/** Response atom for the "meta_ad" table (1:1 with a DB row, on the wire). */
export const metaAdAtomSchema = z.object({
    id: z.string(),
    metaCampaignId: z.string().nullable(),
    metaAdSetId: z.string().nullable(),
    organizationId: z.string(),
    videoId: z.string().nullable(),
    graphicId: z.string().nullable(),
    socialPostId: z.string().nullable(),
    useExistingPost: z.boolean(),
    name: z.string(),
    headline: z.string().nullable(),
    primaryText: z.string().nullable(),
    description: z.string().nullable(),
    callToAction: z.enum(metaCallToActionValues).nullable(),
    destinationUrl: z.string().nullable(),
    isImported: z.boolean(),
    status: z.enum(metaAdStatusValues),
    targetingOverride: z.unknown().nullable(),
    followUpType: z.enum(followUpTypeValues),
    leadFormId: z.string().nullable(),
    sequenceId: z.string().nullable(),
    adPlacement: z.enum(adPlacementValues),
    conversionDestination: z.enum(conversionDestinationAllValues).nullable(),
    destinations: z.array(z.string()).nullable(),
    metaAdsPageId: z.string().nullable(),
    packageId: z.string().nullable(),
    offerId: z.string().nullable(),
    offerLinkSource: z.enum(adLinkSourceValues).nullable(),
    linkMatchAttemptedAt: z.string().datetime().nullable(),
    adAccountId: z.string().nullable(),
    metaAdId: z.string().nullable(),
    metaCreativeId: z.string().nullable(),
    metaVideoId: z.string().nullable(),
    metaImageHash: z.string().nullable(),
    metaStatus: z.string().nullable(),
    lastSyncAt: z.string().datetime().nullable(),
    syncError: z.string().nullable(),
    deletedAt: z.string().datetime().nullable(),
    metaThumbnailUrl: z.string().nullable(),
    metaPermalink: z.string().nullable(),
    creativeAssetId: z.string().nullable(),
    creativeFetchedAt: z.string().datetime().nullable(),
    creativeFetchError: z.string().nullable(),
    aiCreativeSummary: z.string().nullable(),
    aiCreativeSummaryAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=metaAd.js.map